export default __webpack_public_path__ + "static/media/B213.b0cd07f8.png";